import axios from 'axios'
import store from '@state/store'

export default (routeTo, routeFrom, next) => {
  /*
     if the guest has not yet added room to the cart
     redirect to property landing page
  */
  if (store.getters['cart/rooms/isEmpty']) {
    next({
      name: 'property-landing',
      params: routeTo.params,
      query: routeTo.query,
    })
  } else {
    axios
      .post('/api/v2/get_dropdown')
      .then(({ data }) => {
        routeTo.params.dropdown = data

        next()
      })
      .catch(() => {
        next() // 500 - internal server error
      })
  }
}
